import { useEffect, useState } from "react";
import styled from "styled-components";
import type { Option } from "../types/option";

const StyledDropdown = styled("select")`
  border-radius: 5px;
  font-family: inherit;
  color: inherit;
  font-size: 12px;
  width: 100%;
  height: 40px;
  bottom: 5px;
  position: relative;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23666' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  padding-left: 8px;
  padding-right: 28px;
`;

type DropdownProps = {
  id: string;
  options: Option[];
  value?: string;
  disabled?: boolean;
  className?: string;
  onChange: (value: string) => void;
};

const Dropdown = ({ id, options, onChange, ...props }: DropdownProps) => {
  const defaultValue = "--";
  const [value, setValue] = useState<string>(defaultValue);

  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);

  const handleValueChange = (value: string) => {
    setValue(value);
    onChange(value);
  };

  return (
    <StyledDropdown
      id={id}
      name={id}
      value={value}
      disabled={props.disabled}
      className={props.className}
      onChange={(e) => handleValueChange(e.currentTarget.value)}
    >
      <option value={defaultValue}>--</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>{option.label}</option>
      ))}
    </StyledDropdown>
  );
};

export default Dropdown;
